import React, { Component } from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'

import { withCookies } from 'react-cookie'
import withData from 'utils/withData'
import LrsClient from 'utils/lrs_client'

import { Layout, LoadingComponent, ErrorComponent } from 'components'
import { Home, Trails, TrailDetails, Article } from 'views'
import { Routes, Route } from 'react-router-dom'

import './App.css'

LrsClient.enableCrossWindowTracking()

class App extends Component {
  state = {
    isAuthenticated: false,
    isLoading: true,
    allowedAndroid: true,
  }

  componentDidMount() {
    if (parseInt(this.getAndroidVersion(), 10) <= 5) {
      this.setState({ allowedAndroid: false })
    }

    const { cookies } = this.props

    axios({
      method: 'get',
      url: `${process.env.REACT_APP_AUTH_URL}/auth`,
      crossdomain: true,
    })
      .then(response => {
        const authCookies = response.data.data

        authCookies.domain = process.env.REACT_APP_DRUPAL_COOKIE_DOMAIN
        authCookies.expires = new Date(authCookies.expires)

        cookies.set(authCookies.name, authCookies.value, authCookies)

        this.setState({ isLoading: false, isAuthenticated: true })
      })
      .catch(error => {
        this.setState({ isLoading: false })
        console.log(error)
      })

    const { REACT_APP_SENTRY_DSN, REACT_APP_NODE_ENV } = process.env

    if (REACT_APP_SENTRY_DSN) {
      window.Raven.config(REACT_APP_SENTRY_DSN, {
        environment: REACT_APP_NODE_ENV,
      }).install()
    }

    window.PLURALL_TRACKER.pageView()
  }

  getAndroidVersion = () => {
    const ua = navigator.userAgent.toLowerCase()
    const match = ua.match(/android\s([0-9.]*)/i)
    return match ? match[1] : undefined
  }

  render() {
    const { isAuthenticated, isLoading, allowedAndroid } = this.state

    return (
      <div>
        {!allowedAndroid ? (
          <Layout>
            <ErrorComponent message='Olá! Para acessar este conteúdo, é necessário que atualize o sistema Android para a versão 6 ou superior. Por enquanto, você pode acessar normalmente este conteúdo pelo navegador do seu computador.' />
          </Layout>
        ) : (
          <>
            {isLoading && <LoadingComponent />}

            {!isLoading && isAuthenticated && (
              <Layout>
                <Routes>
                  <Route path='/' element={<Home />} />
                  <Route path='/trails' element={<Trails />} />
                  <Route path='/trails/:slug' element={<TrailDetails />} />
                  <Route path='/node/:slug' element={<Article />} />
                  <Route path='/node/:slug/:latest' element={<Article />} />
                </Routes>
              </Layout>
            )}

            {!isLoading && !isAuthenticated && (
              <Layout>
                <ErrorComponent message='Authentication failed.' />
              </Layout>
            )}
          </>
        )}
      </div>
    )
  }
}

App.propTypes = {
  cookies: PropTypes.object.isRequired,
}

export default withCookies(withData(App))
